import { formatDate, getDateByTimeZone } from "@/lib/date";
import { Delivery } from "./Delivery";

export const DISPOSE_APPROVAL_TYPE = {
  MANUAL: { name: "수동 폐기승인", value: "MANUAL" },
  AUTO: { name: "자동 폐기승인", value: "AUTO" },
};

const APPROVAL_TYPE_LABEL = {
  MANUAL: "수동 폐기승인",
  AUTO: "자동 폐기승인",
  수동: "수동 폐기승인",
  자동: "자동 폐기승인",
};

export function mapDisposeApprovalRow(row = {}) {
  const nested =
    row.delivery && typeof row.delivery === "object" ? row.delivery : {};
  const source = Object.keys(nested).length
    ? { ...nested, ...row, delivery: nested }
    : row;
  const delivery = new Delivery({
    ...source,
    bookId: row.bookId || nested.bookId || source.bookId,
    orderIdFromCorp: row.orderIdFromCorp || nested.orderIdFromCorp,
    corpUser: row.corpUser || nested.corpUser,
  });

  delivery.disposeApprovalType =
    row.disposeApprovalType || nested.disposeApprovalType || "";
  delivery.disposeApprovedAt =
    row.approvedAt ||
    row.disposeApprovedAt ||
    row.disposeApprovalDate ||
    nested.approvedAt ||
    nested.disposeApprovedAt ||
    "";
  delivery.damageReason =
    row.damageReason ||
    row.lostReason ||
    nested.damageReason ||
    delivery.lostReason ||
    delivery.accidentReason ||
    "";
  delivery.orderIdFromCorpSub =
    row.orderIdFromCorpSub || nested.orderIdFromCorpSub || "";

  return delivery;
}

export function renderDisposeApprovalType(type) {
  if (type === true) {
    return APPROVAL_TYPE_LABEL.AUTO;
  }

  if (type === false) {
    return APPROVAL_TYPE_LABEL.MANUAL;
  }

  return APPROVAL_TYPE_LABEL[type] || type || "";
}

export function renderDisposeApprovedAt(value) {
  if (!value) {
    return "";
  }

  return formatDate(getDateByTimeZone(value), "yyyy-MM-dd HH:mm");
}
